<template lang="pug">
  ul.b-login-social.list-reset
    li._item
      a._link.-google(href="#" @click="$emit('fillCredentials', 'd1@email.dev', '123')")
        Icon(name="google")
    li._item
      a._link(href="#")
        Icon(name="vk")
    li._item
      a._link(href="#")
        Icon(name="facebook")
    li._item
      a._link(href="#")
        Icon(name="instagram")
</template>

<script>
export default {
  name: 'LoginSocial',
};
</script>

<style scoped lang="scss">
.login-social {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  &__item {
    &:not(:last-child) {
      margin-right: 20px;
    }
  }
  &__link {
    display: block;
    width: 40px;
    height: 40px;
    svg {
      display: block;
      width: 100%;
      height: 100%;
    }
    &--google {
      width: 32px;
      height: 32px;
    }
  }
}
</style>
